import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18572a1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "64",
  y: "2",
  rx: "4",
  ry: "4",
  width: "160",
  height: "40"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "60",
  rx: "4",
  ry: "4",
  width: "240",
  height: "16"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "86",
  rx: "4",
  ry: "4",
  width: "240",
  height: "16"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "84",
  y: "112",
  rx: "4",
  ry: "4",
  width: "120",
  height: "16"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "94",
  y: "160",
  rx: "4",
  ry: "4",
  width: "100",
  height: "60"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "84",
  y: "260",
  rx: "4",
  ry: "4",
  width: "120",
  height: "20"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "44",
  y: "294",
  rx: "4",
  ry: "4",
  width: "200",
  height: "18"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "54",
  y: "320",
  rx: "4",
  ry: "4",
  width: "180",
  height: "16"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "24",
  cy: "383",
  r: "12"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "64",
  y: "374",
  rx: "4",
  ry: "4",
  width: "160",
  height: "16"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "24",
  cy: "418",
  r: "12"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "64",
  y: "409",
  rx: "4",
  ry: "4",
  width: "160",
  height: "16"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "24",
  cy: "453",
  r: "12"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "64",
  y: "444",
  rx: "4",
  ry: "4",
  width: "160",
  height: "16"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "24",
  cy: "488",
  r: "12"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "64",
  y: "479",
  rx: "4",
  ry: "4",
  width: "160",
  height: "16"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "24",
  cy: "523",
  r: "12"
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "64",
  y: "514",
  rx: "4",
  ry: "4",
  width: "160",
  height: "16"
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "24",
  cy: "558",
  r: "12"
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "64",
  y: "549",
  rx: "4",
  ry: "4",
  width: "160",
  height: "16"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_loader = _resolveComponent("content-loader")!
  const _component_md_card = _resolveComponent("md-card")!

  return (_openBlock(), _createBlock(_component_md_card, {
    variant: "filled",
    class: "payment-method-loader"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_content_loader, {
        viewBox: "0 0 288 600",
        speed: 1.2,
        primaryColor: "#dad9e3",
        secondaryColor: "#cecdd8"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _hoisted_12,
          _hoisted_13,
          _hoisted_14,
          _hoisted_15,
          _hoisted_16,
          _hoisted_17,
          _hoisted_18,
          _hoisted_19,
          _hoisted_20
        ]),
        _: 1
      }, 8, ["speed"])
    ]),
    _: 1
  }))
}